<template>
  <v-row>
    <v-col v-for="(hotlink, key) in hotlinks" :key="key">
      <v-card @click="$router.push(hotlink.link)">
        <v-img
          :src="hotlink.image"
          class="white--text align-end"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          height="200px"
        >
          <v-card-title v-text="hotlink.title"></v-card-title>
        </v-img>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import store from "../store";

export default {
  name: "Home",
  computed: {
    hotlinks() {
      return store.menu.filter(item => {
        return item.types.indexOf(store.currentUser.type) >= 0;
      });
    }
  }
};
</script>
